var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereumCarousel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 136.782,
    height: 136.782,
    rx: 27.3563,
    fill: "#161A29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3907 56.6682L40.5366 69.2657L68.3907 85.7153L96.2967 69.2207L68.3907 56.6682Z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3907 56.7717L40.6403 69.2724L68.3907 85.6114L96.1411 69.2205L68.3907 56.7717Z",
    fill: "#454A75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4017 69.2362L68.4011 22.7815L68.3907 85.7671L40.4017 69.2362Z",
    fill: "#62688F",
    fillOpacity: 0.836391
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4012 22.7815L96.3953 69.2362L68.3908 85.7152L68.4012 22.7815Z",
    fill: "#8A92B2",
    fillOpacity: 0.812612
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4011 91.0889V114L40.3861 74.5476L68.4011 91.0889Z",
    fill: "#62688F",
    fillOpacity: 0.810098
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3953 74.5476L68.4011 114V91.0889L96.3953 74.5476Z",
    fill: "#8A92B2",
    fillOpacity: 0.807143
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumCarousel);
export default __webpack_public_path__ + "static/media/ethereum-carousel.cb998c0b99e02be20d44ac965658c867.svg";
export { ForwardRef as ReactComponent };